import { Link, useLocation } from 'react-router-dom';
import { DisplayNameEdit } from './DisplayNameEdit';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

const HIDE_HEADER = new Set(['/play', '/practice']);

function hideHeader(pathname: string) {
  if (HIDE_HEADER.has(pathname)) return true;
  if (pathname === '/arena') return true;
  if (/^\/leagues\/[^/]+\/play\//.test(pathname)) return true;
  return false;
}

export function SiteHeader() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();

  if (hideHeader(pathname)) return null;

  return (
    <header className="site-header">
      <Link to="/" className="site-header-logo">Dezoom</Link>
      <nav className="site-header-nav" aria-label="Navigation principale">
        <Link to="/gallery">{t('gallery.title')}</Link>
        <Link to="/leaderboard">{t('leaderboard.title')}</Link>
        {user && <Link to="/friends">{t('friends.title')}</Link>}
        {user && <Link to="/leagues">{t('leagues.title')}</Link>}
        {user?.isPremium && <Link to="/arena">{t('arena.title')}</Link>}
      </nav>
      <div className="site-header-account">
        {loading ? (
          <span className="site-header-muted">…</span>
        ) : user ? (
          <DisplayNameEdit />
        ) : (
          <Link to="/login" className="site-header-login">{t('landing.login')}</Link>
        )}
      </div>
    </header>
  );
}
